/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createContext, useCallback, useContext, useState } from 'react';

import { Backdrop } from '@mui/material';

import { Spinner } from '~/components/Spinner';

import { FCWithChildren } from '~/types/FCWithChildren';

interface IBackdropContextProps {
  readonly active: boolean;
  readonly activateBackdrop: () => void;
  readonly desactivateBackdrop: () => void;
}

const BackdropContext = createContext<IBackdropContextProps>(
  {} as IBackdropContextProps
);

interface IBackdropProviderProps {
  readonly startsOpen?: boolean;
}

const BackdropProvider: FCWithChildren<IBackdropProviderProps> = ({
  children,
  startsOpen = false,
}) => {
  const [active, setActive] = useState<boolean>(startsOpen);

  const activateBackdrop = useCallback(() => {
    setActive(true);
  }, []);

  const desactivateBackdrop = useCallback(() => {
    setActive(false);
  }, []);

  return (
    <BackdropContext.Provider
      value={{ active, activateBackdrop, desactivateBackdrop }}
    >
      {active && (
        <Backdrop sx={{ color: 'rgb(0, 0, 0)', zIndex: 500 }} open>
          <Spinner />
        </Backdrop>
      )}
      {children}
    </BackdropContext.Provider>
  );
};

const useBackdrop = () => useContext(BackdropContext);

export { useBackdrop, BackdropProvider };
